import { useState } from "react";
import { ChatCircleDots } from "@phosphor-icons/react";
import { FeedbackModal } from "@/components/FeedbackModal";
import tmdbLogo from "@/assets/tmdb-logo.svg";

const YEAR = new Date().getFullYear();

// Slim, Letterboxd-style attribution + copyright strip. Rendered at the
// bottom of every app page. Also carries the one persistent "Feedback"
// entry point into the Feedback & Support System.
export function AppFooter({ className = "" }) {
  const [fbOpen, setFbOpen] = useState(false);
  return (
    <footer
      data-testid="app-footer"
      className={`mt-16 flex flex-col items-center gap-2 border-t border-white/[0.06] pt-5 text-center sm:flex-row sm:justify-between sm:text-left ${className}`}
    >
      <p data-testid="footer-attribution-text" className="flex flex-wrap items-center justify-center gap-x-1 text-[12px] text-faint sm:justify-start">
        <span>This application uses TMDB and the TMDB APIs but is not endorsed, certified, or otherwise approved by</span>
        <a
          href="https://www.themoviedb.org/"
          target="_blank"
          rel="noopener noreferrer"
          title="The Movie Database"
          data-testid="footer-attribution-link"
          className="inline-flex translate-y-[1px] items-center opacity-80 transition-opacity hover:opacity-100"
        >
          <img src={tmdbLogo} alt="TMDB" className="h-2 w-auto" />
        </a>
        <span>.</span>
      </p>
      <div className="flex items-center gap-4">
        <button
          data-testid="footer-feedback-link"
          onClick={() => setFbOpen(true)}
          className="flex items-center gap-1.5 text-[12px] font-semibold text-faint transition-colors hover:text-gold"
        >
          <ChatCircleDots size={14} /> Feedback
        </button>
        <p className="text-[12px] text-faint">© {YEAR} Silver Schnauzer Studios LLC. All rights reserved.</p>
      </div>
      <FeedbackModal open={fbOpen} onClose={() => setFbOpen(false)} defaultCategory="feature" />
    </footer>
  );
}
